import { render } from "./SurveyQ11OptrRating.vue?vue&type=template&id=196ce98c&ts=true"
import script from "./SurveyQ11OptrRating.vue?vue&type=script&lang=ts"
export * from "./SurveyQ11OptrRating.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__